import React from 'react'
import { Icon, Tooltip } from 'antd'

import { RequestQuoteAirFare } from 'src/types'
import { stringify } from 'src/core/hooks/use-translation'
import { Text } from 'src/components/Ant'

type Props = Pick<
  RequestQuoteAirFare,
  'baggage_amount' | 'baggage_weight' | 'baggage' | 'family'
>

function TagFamily({ baggage_amount, baggage_weight, baggage, family }: Props) {
  const baggages = (
    <span
      style={{
        marginLeft: 8,
        position: 'relative'
      }}
    >
      {baggage ? (
        <Tooltip
          title={
            <>
              <Text
                onlyText
                title={stringify('web.services.airs.form.fare.baggage-amount', {
                  count: baggage_amount
                })}
              />
              ,{' '}
              <Text
                onlyText
                title={stringify('web.services.airs.form.fare.baggage-weight', {
                  count: baggage_weight
                })}
              />
            </>
          }
        >
          <Icon type="shopping" />
        </Tooltip>
      ) : (
        <>
          <Icon type="shopping" />
          <Icon
            type="close"
            style={{
              position: 'absolute',
              top: 3,
              left: 0,
              margin: 0
            }}
          />
        </>
      )}
    </span>
  )

  return (
    <>
      {family}
      {baggages}
    </>
  )
}

export default TagFamily
